<template lang="pug">
div
	h3.has-text-left Your signature is required for survey response.
	.instructions
		div.has-text-left
			h4 Please sign below
		div.pad
			canvas#signature
	div.flex.pad(v-if='signature_completed && !confirmed')
		.flex-grow
			button.button.is-large.is-fullwidth.is-success(@click='save_signature') Confirm
		.flex-shrink
			button.button.is-large.is-fullwidth.is-light(@click='clear_signature') Erase
	hr
</template>

<script>
import SignaturePad from "../../node_modules/signature_pad/dist/signature_pad.js";

export default {
  name: "Signature",
  data: function() {
    return {
      signaturePad: null,
      confirmed: false
    };
  },
  computed: {
    signature_completed() {
      if (!this.signaturePad || this.signaturePad.isEmpty()) return false;

      return true;
    }
  },

  props: {},
  mounted: function() {
    setTimeout(() => {
      const canvas = document.getElementById("signature");
      if (canvas) {
        // eslint-disable-next-line no-undef
        this.signaturePad = new SignaturePad(canvas, {
          minWidth: 1,
          maxWidth: 5
        });
        this.resizeCanvas();
      }
    }, 5);
  },
  methods: {
    clear_signature: function() {
      this.signaturePad.clear();
    },
    resizeCanvas: function() {
      var ratio = Math.max(window.devicePixelRatio || 1, 1);
      const canvas = document.getElementById("signature");
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      canvas.getContext("2d").scale(ratio, ratio);
      this.signaturePad.clear();
    },
    save_signature() {
      let signature = undefined;

      if (this.signaturePad && !this.signaturePad.isEmpty()) {
        signature = this.signaturePad.toDataURL();
        this.$emit("signature", signature);
        this.confirmed = true;
      }
    }
  }
};
</script>

<style scoped lang="less">
.flex-grow {
  margin-right: 1rem;
}
.flex {
  padding: 0.5rem;
}
.instructions {
  background-color: #efefef;
  padding: 1rem;
}
.pad {
  background-color: white;
  padding: 0.5rem !important;
}
h3 {
  padding-left: 0.5rem;
}
</style>